import {ActionIcon} from "@mantine/core";
import {useTranslation} from "react-i18next";
import AdjustmentsSvg from "../../../assets/adjustments.svg?react";
import {ActionButtons} from "./ActionButtons";
import type {CollectionDataResponse} from "../types";
import styles from "./checklist.module.css";

type ChecklistMobileToolbarProps = {
    topicName: string;
    displayTitle: string;
    collectionData?: CollectionDataResponse;
    hasGlobalFilters: boolean;
    filterOpen: boolean;
    onToggleFilter: () => void;
    setEditFillingOpen: (open: boolean) => void;
    setCreateFillingOpen: (open: boolean) => void;
    setOpenFillingOpen: (open: boolean) => void;
    setShareFillingOpen: (open: boolean) => void;
    setDuplicateFillingOpen: (open: boolean) => void;
    setDeleteFillingOpen: (open: boolean) => void;
};

/**
 * Persistent narrow-viewport toolbar pinned beneath the app tabs. Replaces the
 * old grey hamburger navbar + drawer. Carries the collection title, the full
 * collection action branching (reused `ActionButtons`), and — when the checklist
 * exposes global filters — a sliders toggle that opens the filter Collapse.
 */
export const ChecklistMobileToolbar = ({
    topicName,
    displayTitle,
    collectionData,
    hasGlobalFilters,
    filterOpen,
    onToggleFilter,
    setEditFillingOpen,
    setCreateFillingOpen,
    setOpenFillingOpen,
    setShareFillingOpen,
    setDuplicateFillingOpen,
    setDeleteFillingOpen,
}: ChecklistMobileToolbarProps) => {
    const {t} = useTranslation();

    return (
        <div className={styles.mobileToolbar}>
            <div className={styles.mobileToolbarTitle}>
                <span className={styles.mobileToolbarTopicName}>
                    {topicName}
                </span>
                <span className={styles.mobileToolbarFillingTitle}>
                    {displayTitle}
                </span>
            </div>

            <div className={styles.mobileToolbarActions}>
                <ActionButtons
                    collectionData={collectionData}
                    setEditFillingOpen={setEditFillingOpen}
                    setCreateFillingOpen={setCreateFillingOpen}
                    setOpenFillingOpen={setOpenFillingOpen}
                    setShareFillingOpen={setShareFillingOpen}
                    setDuplicateFillingOpen={setDuplicateFillingOpen}
                    setDeleteFillingOpen={setDeleteFillingOpen}
                />

                {hasGlobalFilters && (
                    <ActionIcon
                        variant="subtle"
                        color="gray"
                        onClick={onToggleFilter}
                        aria-label={t("Action.Settings", {
                            defaultValue: "Settings",
                        })}
                        title={t("Action.Settings", {defaultValue: "Settings"})}
                        aria-expanded={filterOpen}
                        data-active={filterOpen || undefined}
                    >
                        <AdjustmentsSvg />
                    </ActionIcon>
                )}
            </div>
        </div>
    );
};
